<mat-dialog-content>
  @if (data.error) {
    <div class="error-header">
      <mat-label>{{'dialog.user-admin.new-password.failure' | translate}}</mat-label>
    </div>
  }
  <mat-label>{{'dialog.user-admin.new-password.show' | translate:param}}</mat-label>
</mat-dialog-content>
